import { Lock } from "lucide-react";

const PAYMENT_METHODS = [
  { id: "americanexpress", name: "American Express" },
  { id: "applepay", name: "Apple Pay" },
  { id: "dinersclub", name: "Diners Club" },
  { id: "discover", name: "Discover" },
  { id: "googlepay", name: "Google Pay" },
  { id: "mastercard", name: "Mastercard" },
  { id: "paypal", name: "PayPal" },
  { id: "shopify", name: "Shop Pay" },
  { id: "venmo", name: "Venmo" },
  { id: "visa", name: "Visa" },
];

const ICON_BASE = "https://cdn.simpleicons.org";

export default function PaymentSecurity() {
  return (
    <section
      data-testid="payment-security-section"
      className="border-t border-[#E5E2DA] bg-[#EFEDE7] text-[#1C1C1C] py-16 lg:py-20"
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-[auto_1fr] gap-10 lg:gap-16 items-start">
        <div>
          <div className="overline text-[#5C5C5C] flex items-center gap-2">
            <Lock size={12} strokeWidth={2} className="text-[#C9A961]" />
            Payment & Security
          </div>
          <h3 className="font-serif-editorial text-2xl lg:text-3xl mt-3 leading-tight">
            Every checkout, protected
          </h3>
        </div>
        <div>
          <div className="flex flex-wrap gap-3" data-testid="payment-methods">
            {PAYMENT_METHODS.map((m) => (
              <div
                key={m.id}
                data-testid={`payment-method-${m.id}`}
                title={m.name}
                className="h-10 w-16 bg-white rounded-md flex items-center justify-center overflow-hidden ring-1 ring-[#D8D3C7] transition-transform duration-300 hover:-translate-y-0.5"
              >
                <img
                  src={`${ICON_BASE}/${m.id}/_default`}
                  alt={m.name}
                  loading="lazy"
                  className="max-h-6 max-w-[46px] object-contain"
                />
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm text-[#5C5C5C] leading-relaxed max-w-xl">
            Your payment information is processed securely. We do not store credit card details nor have access to your credit card information. All transactions are encrypted end-to-end via Stripe's PCI-DSS Level 1 infrastructure.
          </p>
        </div>
      </div>
    </section>
  );
}
